import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class noteGraphQL extends GraphQlService {
  async getNoteById(accountId, id) {
    return this.client
      .query({
        query: gql`
            query {
                getNoteById(
                  accountId: "${accountId}",
                  id: "${id}"
                ) {
                  id
                  accountId
                  userId
                  note
                  type
                  creatorName
                  createdAt
                      createdBy
                      updatedAt
                      updatedBy
                      pinned
                      isPublic
                      user{
                        accountPeople{
                          name
                          isAnonymous
                          anonymousName
                          accountPersonAttributes{
                            id
                            name
                            value
                          }
                        }
                      }
                }
            }
        `,
      })
      .then((result) => result?.data?.getNoteById);
  }

  async updateNoteNote(data) {
    const {
      id,
      accountId,
      userId,
      note,
      creatorName,
      type,
      pinned = false,
      isPublic = false,
    } = data;
    return this.client
      .mutate({
        mutation: gql`
          mutation {
           updateNoteNote(
                updateNoteNoteInput: {
                id: "${id}"
                accountId: "${accountId}"
                userId: "${userId}"
                note: """${note}"""
                creatorName: "${creatorName}"
                type: "${type}"
                pinned: ${pinned}
                isPublic: ${isPublic}
                }
            ) {
                id
                accountId
                userId
                note
                type
                creatorName
                createdAt
                createdBy
                updatedAt
                updatedBy
                pinned
                isPublic
                user {
                accountPeople {
                    name
                    isAnonymous
                    anonymousName
                    accountPersonAttributes {
                    id
                    name
                    value
                    }
                }
                }
            }
        }
        `,
      })
      .then((result) => result?.data?.updateNoteNote);
  }
}

const noteGraphqlInstance = new noteGraphQL();
export default noteGraphqlInstance;
